var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlider1Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4861,
    cy: 44,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5863 36.0919V49.9636C40.5863 51.0953 39.6647 52.1336 38.533 52.2736L38.1713 52.3203C36.258 52.5769 33.563 53.3703 31.393 54.2803C30.6347 54.5953 29.7947 54.0236 29.7947 53.1953V36.9669C29.7947 36.5353 30.0397 36.1386 30.4247 35.9286C32.5597 34.7736 35.7913 33.7469 37.9847 33.5603H38.0547C39.4547 33.5603 40.5863 34.6919 40.5863 36.0919Z",
    fill: "#6374FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4147 35.9286C25.2797 34.7736 22.048 33.7469 19.8547 33.5603H19.773C18.373 33.5603 17.2413 34.6919 17.2413 36.0919V49.9636C17.2413 51.0953 18.163 52.1336 19.2947 52.2736L19.6563 52.3203C21.5697 52.5769 24.2647 53.3703 26.4347 54.2803C27.193 54.5953 28.033 54.0236 28.033 53.1953V36.9669C28.033 36.5236 27.7997 36.1386 27.4147 35.9286ZM20.753 39.4636H23.378C23.8563 39.4636 24.253 39.8603 24.253 40.3386C24.253 40.8286 23.8563 41.2136 23.378 41.2136H20.753C20.2747 41.2136 19.878 40.8286 19.878 40.3386C19.878 39.8603 20.2747 39.4636 20.753 39.4636ZM24.253 44.7136H20.753C20.2747 44.7136 19.878 44.3286 19.878 43.8386C19.878 43.3603 20.2747 42.9636 20.753 42.9636H24.253C24.7313 42.9636 25.128 43.3603 25.128 43.8386C25.128 44.3286 24.7313 44.7136 24.253 44.7136Z",
    fill: "#6374FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5725 5.78625L52.4036 17.4717",
    stroke: "#6374FA",
    strokeWidth: 3.125,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5139 25.3485L56.4898 27.2067",
    stroke: "#6374FA",
    strokeWidth: 3.125,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.486 2L40.4861 12.3289",
    stroke: "#6374FA",
    strokeWidth: 3.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider1Icon);
export default __webpack_public_path__ + "static/media/slider1icon.89be24d26b46d802ee61160a46a291c9.svg";
export { ForwardRef as ReactComponent };